import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {environment} from "@environment";
import {Router} from "@angular/router";
import {OrderService} from "@services/order.service";
import {UrlService} from "@services/url.service";

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceComponent implements OnInit {
    order: any;
    shop: any;
    networkClass;
    mainWebsiteLink: string;
    mainWebsiteLinkLabel: string;

    constructor(
        private router: Router,
        private orderService: OrderService,
        private urlService: UrlService,
    ) {
    }

    ngOnInit(): void {
        if (!environment.maintenance) {
            this.router.navigateByUrl('/').then();
        }
        this.orderService.orderBS.subscribe((order) => {
            this.order = order;
        });
        this.shop = this.urlService.getShop();
        this.networkClass = this.urlService.getNetwork();
        if (this.networkClass == 'sm') {
            this.mainWebsiteLink = environment.sm_main_website_url
            this.mainWebsiteLinkLabel = environment.sm_main_website_url
        } else if (this.networkClass == 'mm') {
            this.mainWebsiteLink = environment.mm_main_website_url
            this.mainWebsiteLinkLabel = environment.mm_main_website_url
        } else if (this.networkClass == 'tg') {
            this.mainWebsiteLink = environment.tg_main_website_url
            this.mainWebsiteLinkLabel = environment.tg_main_website_url
        }
        this.mainWebsiteLink = 'https://www.' + this.mainWebsiteLink;
    }

}
